import { Button, IconSet } from '@postscript/components';
import React from 'react';
import styled, { css } from 'styled-components';

const ThumbsContainer = styled.div`
  display: inline-flex;
  align-items: center;
`;

const ThumbControl = styled(Button)<{
  $feedback: 'positive' | 'negative';
  $filled: boolean;
}>`
  --btn-color-negative: var(--red-6);
  --btn-color-positive: var(--green-6);

  padding: 0;
  min-width: 24px;
  min-height: 24px;

  ${({ $feedback, $filled }) =>
    $filled && `--btn-color: var(--btn-color-${$feedback}) !important;`}

  ${({ $feedback }) =>
    css`
      &:hover {
        --btn-color: var(--btn-color-${$feedback}) !important;
      }
    `}
`;

export interface FeedbackThumbsProps {
  feedback: 'POSITIVE' | 'NEGATIVE' | '';
  disabled?: boolean;
  onThumbsUp: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onThumbsDown: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export const FeedbackThumbs: React.FC<FeedbackThumbsProps> = ({
  feedback,
  disabled = false,
  onThumbsUp,
  onThumbsDown,
}) => (
  <ThumbsContainer>
    <ThumbControl
      $feedback="positive"
      $filled={feedback === 'POSITIVE'}
      icon={feedback === 'POSITIVE' ? IconSet.ThumbsUpFilled : IconSet.ThumbsUp}
      onClick={onThumbsUp}
      aria-label="Like message"
      aria-pressed={feedback === 'POSITIVE'}
      data-testid="thumbs-up"
      monochrome
      variant="text"
      size="small"
      disabled={disabled}
    />
    <ThumbControl
      $feedback="negative"
      $filled={feedback === 'NEGATIVE'}
      icon={
        feedback === 'NEGATIVE' ? IconSet.ThumbsDownFilled : IconSet.ThumbsDown
      }
      onClick={onThumbsDown}
      aria-label="Dislike message"
      aria-pressed={feedback === 'NEGATIVE'}
      data-testid="thumbs-down"
      monochrome
      variant="text"
      size="small"
      disabled={disabled}
    />
  </ThumbsContainer>
);
